import React, {PureComponent} from 'react'
import {Form, Input, Modal, DatePicker, message, Select,} from 'antd'
import {reqFactoryCodes,} from '../../api'
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');
const {Option} = Select;
const formItemLayout = {
    labelCol: {
        span: 6,
    },
    wrapperCol: {
        span: 14,
    },
}
const title = {
    add: '新增GPS设备',
    update: '修改GPS设备'
}
class DeviceModal extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            factoryCodes: [],
        }
    }

    handleOk = () => {
        const {onOk} = this.props;
        const {validateFields, getFieldsValue,} = this.props.form
        validateFields((errors, values) => {
            if (errors) {
                return
            }
            const data = {...getFieldsValue()};
            if (data.lastSynDt) {
                data.lastSynDt = data.lastSynDt.format("YYYY-MM-DD HH:mm:ss");
            }
            onOk(data);
        })
    }
    hideModal = () => {
        const {onCancel} = this.props
        onCancel()
    }
    afterClose = () => {
        const {resetFields} = this.props.form
        resetFields()
    }

    componentDidMount() {
        this.getFactoryCodes();
        this.props.onRef(this);
    }

    getFactoryCodes = async () => {
        let result = await reqFactoryCodes()
        if (result.code === 200) {
            this.setState({
                factoryCodes: [...result.data],
            })
        } else {
            message.error(result.message)
        }
    }

    render() {
        const {getFieldDecorator} = this.props.form;
        const {deviceView, action} = this.props;
        const {factoryCodes} = this.state;
        const options = (factoryCodes || []).map(d => <Option key={d.trailFactoryCode}
                                                              value={d.trailFactoryCode}>{d.trailFactoryCodeName}</Option>)
        return (
            <Modal onOk={this.handleOk}
                   title={title[action]}
                   visible={deviceView}
                   onCancel={this.hideModal}
                   afterClose={this.afterClose}
                   okText="确定"
                   cancelText="取消"
            >
                <Form {...formItemLayout}>
                    <Form.Item label="GPS设备号:">
                        {getFieldDecorator('deviceId', {
                            rules: [{required: true, message: '该项必填'}]
                        })(<Input />)}
                    </Form.Item>
                    <Form.Item label="厂家号:">
                        {getFieldDecorator('factoryCode', {
                            rules: [{required: true, message: '该项必填'}]
                        })(<Select>
                            {options}
                        </Select>)}
                    </Form.Item>
                    <Form.Item label="最后同步时间" className='time-input-to'>
                        {getFieldDecorator('lastSynDt', {
                            initialValue: moment(new Date(), 'YYYY-MM-DD HH:mm:ss')
                        })(<DatePicker
                            showTime
                            format="YYYY-MM-DD HH:mm:ss"
                            style={{width: "100%", minWidth: 10}}
                        />)}

                    </Form.Item>
                </Form>
            </Modal>
        )
    }
}
const WrapDeviceModal = Form.create()(DeviceModal)
export default WrapDeviceModal
